import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ListItemSelectionService {
  private selectedItemsSubject = new BehaviorSubject<Set<string>>(new Set());
  selectedItems$ = this.selectedItemsSubject.asObservable();

  constructor() {}

  toggleItemSelection(listItem: string) {
    if (this.selectedItems.has(listItem)) {
      this.selectedItems.delete(listItem);
    } else {
      this.selectedItems.add(listItem);
    }

    this.selectedItemsSubject.next(new Set(this.selectedItems));
  }

  get selectedItems() {
    return this.selectedItemsSubject.value;
  }

  toggleAllItemsSelection(setItems: Set<string>) {
    if (this.selectedItems.size === setItems.size) {
      this.clearSelection();
    } else {
      this.selectAllItems(setItems);
    }
  }

  private selectAllItems(listItems: Set<string>) {
    this.selectedItemsSubject.next(new Set(listItems));
  }

  clearSelection(): void {
    this.selectedItemsSubject.next(new Set());
  }
}
